import React from "react";
import { Col, ColorPicker, Row, Space } from "antd";
import { ColumnProps } from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  // {
  //   key: "2",
  //   title: "Mã trình tự",
  //   dataIndex: "maTrinhTu",
  //   align: "left",
  //   width: 80,
  // },
  {
    key: "3",
    title: "Tên mẫu",
    dataIndex: "tenMau",
    align: "left",
    width: 250,
    ellipsis: true,
  },
  {
    key: "3",
    title: "Trạng thái",
    dataIndex: "idTrangThaiDanhMucPhauThuat",
    align: "left",
    render: (text) => (text == 0 ? "Đang sử dụng" : "Dừng sủ dụng"),
    width: 150,
  },

  { key: "4", title: "Thao tác", dataIndex: "action", width: 20 },
];
export { columns };
